export default {
  title: 'Dlaczego wygenerować obraz ponownie?',
  description: 'Pomóż nam ulepszyć AI, mówiąc nam, co było nie tak.',
  reasons: {
    wrong_style: 'Nieprawidłowy styl',
    wrong_colors: 'Nieprawidłowe kolory',
    wrong_food_item: 'Nieprawidłowe danie',
    low_quality: 'Niska jakość',
    doesnt_match_brand: 'Nie pasuje do mojej marki',
    text_issues: 'Tekst lub etykiety są nieprawidłowe',
    other: 'Inne',
  },
  details_label: 'Coś jeszcze? (opcjonalnie)',
  details_placeholder: 'Dodaj szczegóły, aby pomóc nam zrozumieć…',
  cancel: 'Anuluj',
  confirm: 'Wygeneruj ponownie',
};
